import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client/core'
import gql from 'graphql-tag'

const httpLink = createHttpLink({
  uri: 'https://eu-central-1-shared-euc1-02.cdn.hygraph.com/content/cm0wpc88h02cq07uxfuaeo0gq/master'
})

const apolloClient = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache()
})

const query = gql`
  query News {
  newss {
    id
    title
    description
    image {
      url
    }
    page {
      html
    }
    publishedAt
  }
}
`

export const useNewsStore = defineStore('News', () => {
  const newssData = ref([])
  const news = computed(() => newssData)
  
  function init() {
    apolloClient
      .query({
        query
      })
      .then(({ data }) => {
        newssData.value = data.newss
      });
  }

  
  return { news, init }
})
